import React, {
    useEffect,
    useState
} from "react";

import {
    Link,
    useNavigate
} from "react-router-dom";

import API from "../../services/api";
import { hasPermission } from "../../utils/permission";

function Products() {

    const navigate =
        useNavigate();

    const [products,
        setProducts] =
        useState([]);

    const [page,
        setPage] =
        useState(1);

    const [pages,
        setPages] =
        useState(1);

    const [search,
        setSearch] =
        useState("");

    useEffect(() => {
        loadProducts();
    }, [page, search]);

    const loadProducts =
        async () => {

            try {

                const token =
                    localStorage.getItem(
                        "adminToken"
                    );

                const res =
                    await API.get(
                        `/products?page=${page}&search=${search}`,
                        {
                            headers: {
                                Authorization:
                                    `Bearer ${token}`
                            }
                        }
                    );

                setProducts(
                    res.data.products
                );

                setPages(
                    res.data.pages
                );

            } catch (err) {
                console.log(err);
            }

        };

    const deleteProduct =
        async (id) => {

            if (
                !window.confirm(
                    "Delete Product?"
                )
            ) return;

            try {

                const token =
                    localStorage.getItem(
                        "adminToken"
                    );

                await API.delete(
                    `/products/${id}`,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`
                        }
                    }
                );

                loadProducts();

            } catch (err) {
                console.log(err);
            }

        };

    return (
        <div>

            <div
                className="
        flex
        flex-col
        md:flex-row
        md:items-center
        md:justify-between
        gap-4
        mb-6
        "
            >

                <h1
                    className="
          text-3xl
          md:text-4xl
          font-bold
          "
                >
                    Products
                </h1>

                {hasPermission("product.add") && (
                    <Link
                        to="/admin/products/add"
                        className="
          bg-yellow-500
          text-black
          px-5
          py-3
          rounded-xl
          font-semibold
          text-center
          "
                    >
                        Add Product
                    </Link>
                )}

            </div>

            <input
                value={search}
                onChange={(e) =>
                    setSearch(
                        e.target.value
                    )
                }
                placeholder="Search Product..."
                className="
        w-full
        md:w-96
        p-3
        rounded-xl
        bg-[#111]
        border
        border-yellow-500/20
        mb-6
        "
            />

            {/* MOBILE */}

            <div className="md:hidden space-y-4">

                {products.map(
                    (item) => (

                        <div
                            key={item.id}
                            className="
              bg-[#111]
              rounded-2xl
              p-4
              border
              border-yellow-500/10
              "
                        >

                            <div className="flex justify-between">
                                <span>Name</span>
                                <span>
                                    {item.name}
                                </span>
                            </div>

                            <div className="flex justify-between mt-2">
                                <span>Category</span>
                                <span>
                                    {item.category_name}
                                </span>
                            </div>

                            <div className="flex justify-between mt-2">
                                <span>Stock</span>
                                <span>
                                    {item.stock}
                                </span>
                            </div>

                            <div className="flex justify-between mt-2">
                                <span>Price</span>
                                <span>
                                    ₹{item.selling_price}
                                </span>
                            </div>

                            <div className="flex justify-between mt-2">
                                <span>Status</span>

                                <span
                                    className={
                                        Number(item.status) === 1
                                            ? "text-green-500"
                                            : "text-red-500"
                                    }
                                >
                                    {Number(item.status) === 1
                                        ? "Active"
                                        : "Inactive"}
                                </span>

                            </div>

                            <div className="flex gap-2 mt-4">
                                {hasPermission("product.edit") && (
                                    <button
                                        onClick={() =>
                                            navigate(
                                                `/admin/products/edit/${item.id}`
                                            )
                                        }
                                        className="
                                        flex-1
                                        py-2
                                        bg-blue-500
                                        rounded-lg
                                        "
                                    >
                                        Edit
                                    </button>
                                )}

                                {hasPermission("product.delete") && (
                                    <button
                                        onClick={() =>
                                            deleteProduct(
                                                item.id
                                            )
                                        }
                                        className="
                                        flex-1
                                        py-2
                                        bg-red-500
                                        rounded-lg
                                        "
                                    >
                                        Delete
                                    </button>
                                )}

                            </div>

                        </div>

                    )
                )}

            </div>

            {/* DESKTOP */}

            <div
                className="
        hidden
        md:block
        bg-[#111]
        rounded-2xl
        overflow-hidden
        "
            >

                <div className="overflow-x-auto">

                    <table className="w-full">

                        <thead>

                            <tr
                                className="
                border-b
                border-yellow-500/20
                "
                            >

                                <th className="p-4 text-left">
                                    ID
                                </th>

                                <th className="p-4 text-left">
                                    Product
                                </th>

                                <th className="p-4 text-left">
                                    Category
                                </th>

                                <th className="p-4 text-center">
                                    SKU
                                </th>

                                <th className="p-4 text-center">
                                    Stock
                                </th>

                                <th className="p-4 text-center">
                                    Purchase
                                </th>

                                <th className="p-4 text-center">
                                    Selling
                                </th>

                                <th className="p-4 text-center">
                                    GST
                                </th>

                                <th className="p-4 text-center">
                                    Status
                                </th>

                                <th className="p-4 text-center">
                                    Action
                                </th>

                            </tr>

                        </thead>

                        <tbody>

                            {products.map(
                                (item) => (

                                    <tr
                                        key={item.id}
                                        className="
                    border-b
                    border-yellow-500/10
                    "
                                    >

                                        <td className="p-4">
                                            {item.id}
                                        </td>

                                        <td className="p-4">
                                            {item.name}
                                        </td>

                                        <td className="p-4">
                                            {item.category_name}
                                        </td>

                                        <td className="p-4 text-center">
                                            {item.sku}
                                        </td>

                                        <td className="p-4 text-center">
                                            {item.stock}
                                        </td>

                                        <td className="p-4 text-center">
                                            ₹{item.purchase_price}
                                        </td>

                                        <td className="p-4 text-center">
                                            ₹{item.selling_price}
                                        </td>

                                        <td className="p-4 text-center">
                                            {item.gst_percent}%
                                        </td>

                                        <td className="p-4 text-center">

                                            <span
                                                className={
                                                    Number(item.status) === 1
                                                        ? "text-green-500"
                                                        : "text-red-500"
                                                }
                                            >
                                                {Number(item.status) === 1
                                                    ? "Active"
                                                    : "Inactive"}
                                            </span>

                                        </td>

                                        <td className="p-4">

                                            <div
                                                className="
                                                flex
                                                justify-center
                                                gap-2
                                                "
                                            >

                                                {hasPermission("product.edit") && (
                                                    <button
                                                        onClick={() =>
                                                            navigate(
                                                                `/admin/products/edit/${item.id}`
                                                            )
                                                        }
                                                        className="
                                                        px-4
                                                        py-2
                                                        bg-blue-500
                                                        rounded-lg
                                                        "
                                                    >
                                                        Edit
                                                    </button>
                                                )}

                                                {hasPermission("product.delete") && (
                                                    <button
                                                        onClick={() =>
                                                            deleteProduct(
                                                                item.id
                                                            )
                                                        }
                                                        className="
                          px-4
                          py-2
                          bg-red-500
                          rounded-lg
                          "
                                                    >
                                                        Delete
                                                    </button>
                                                )}

                                            </div>

                                        </td>

                                    </tr>

                                )
                            )}

                        </tbody>

                    </table>

                </div>

            </div>



            {/* PAGINATION */}

            <div className="flex items-center gap-2 mt-6 flex-wrap">

                <button
                    disabled={page === 1}
                    onClick={() => setPage(page - 1)}
                    className={`
      px-4 py-2 rounded-lg
      ${page === 1
                            ? "bg-[#111] opacity-50 cursor-not-allowed"
                            : "bg-[#111] hover:bg-yellow-500 hover:text-black"
                        }
    `}
                >
                    Back
                </button>

                {Array.from(
                    { length: pages },
                    (_, i) => i + 1
                )
                    .filter(
                        p =>
                            p === 1 ||
                            p === pages ||
                            (p >= page - 1 &&
                                p <= page + 1)
                    )
                    .map((p, index, arr) => (
                        <React.Fragment key={p}>

                            {index > 0 &&
                                arr[index - 1] !== p - 1 && (
                                    <span className="px-2">
                                        ...
                                    </span>
                                )}

                            <button
                                onClick={() => setPage(p)}
                                className={`
            px-4 py-2 rounded-lg
            ${page === p
                                        ? "bg-yellow-500 text-black"
                                        : "bg-[#111]"
                                    }
          `}
                            >
                                {p}
                            </button>

                        </React.Fragment>
                    ))}

                <button
                    disabled={page === pages}
                    onClick={() => setPage(page + 1)}
                    className={`
      px-4 py-2 rounded-lg
      ${page === pages
                            ? "bg-[#111] opacity-50 cursor-not-allowed"
                            : "bg-[#111] hover:bg-yellow-500 hover:text-black"
                        }
    `}
                >
                    Next
                </button>

            </div>

        </div>
    );
}

export default Products;